import { apiRequest } from "@api/configs/axios.config";
import { useQuery } from "@tanstack/react-query";
import { IGetAllPartnerDocumentParams } from "./partnerdocument.type";

export const useGetAllPartnerDocument = ({
  partnerId,
  documentName,
}: IGetAllPartnerDocumentParams) => {
  const allPartnerDocumentServices = useQuery({
    queryKey: [partnerId, documentName],
    queryFn: () =>
      apiRequest.get(`partners/${partnerId}/documents/${documentName}`, {
        responseType: "blob",
      }),
    enabled: !!partnerId && !!documentName,
  });

  return {
    services: {
      allPartnerDocumentServices,
    },
  };
};
